import Hero from '@/sections/Hero';
import ShopFavourites from '@/sections/ShopFavourites';
import ShopByGoal from '@/sections/ShopByGoal';
import TeaQuiz from '@/sections/TeaQuiz';
import HeroIngredients from '@/sections/HeroIngredients';
import Reviews from '@/sections/Reviews';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function Landing() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 200);
    }
  }, [location]);

  return (
    <>
      <Hero />
      <ShopFavourites />
      <ShopByGoal />
      <TeaQuiz />
      <HeroIngredients />
      <Reviews />
    </>
  );
}
